import logo from "./logo.svg";
import "./App.css";
import { useParams, useNavigate } from "react-router-dom";
import data from "./data";
import Modal from "./Modal";
import Card from "./Card";
import { useEffect, useState } from "react";
import Help from "./Help";

function App() {
  const { unite, nombre } = useParams();
  const [listUnites, setListUnites] = useState({});
  const [listNombres, setListNombres] = useState({});
  const [uniteTab, setUniteTab] = useState([]);
  const [nombreTab, setNombreTab] = useState([]);
  const [input, setInput] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [modalIsDisplayed, setModalIsDisplayed] = useState(false);
  const [isCorrect, setIsCorrect] = useState();
  const [result, setResult] = useState();
  const [helpIsDisplayed, setHelpIsDisplayed] = useState(false);
  const arrayValidUnite = [
    "U1",
    "U2",
    "U3",
    "U4",
    "U5",
    "U6",
    "U7",
    "U8",
    "U9",
    "U10",
  ];
  const arrayValidNombre = ["N1", "N2", "N3", "N4", "N5"];
  const navigate = useNavigate();
  const regexNumber = /[+-]?([0-9]*[.])?[0-9]+/;

  useEffect(() => {
    if (
      !arrayValidNombre.includes(nombre) ||
      !arrayValidUnite.includes(unite)
    ) {
      navigate("/404");
    }
    Object.keys(data).map((item) => {
      Object.keys(data[item]).map((key) => {
        if (key === unite) {
          setListUnites(data[item][key]);
        }
        if (key === nombre) {
          setListNombres(data[item][key]);
        }
      });
    });
  }, []);

  function toggleModal() {
    setModalIsDisplayed(!modalIsDisplayed);
  }

  function handleUnite(unite, select) {
    let isUnique = true;
    let tab = [...uniteTab];

    if (!select) {
      setUniteTab([...tab, unite]);
    } else {
      for (let i = uniteTab.length - 1; i >= 0; i--) {
        if (uniteTab[i] === unite && isUnique) {
          tab.splice(i, 1);

          isUnique = false;
        }
      }
      setUniteTab(tab);
    }
  }
  function handleNombre(nombre, select) {
    let isUnique = true;
    let tab = [...nombreTab];
    if (!select) {
      setNombreTab([...tab, nombre]);
    } else {
      for (let i = nombreTab.length - 1; i >= 0; i--) {
        if (nombreTab[i] === nombre && isUnique) {
          tab.splice(i, 1);
          isUnique = false;
        }
      }
      setNombreTab(tab);
    }
  }
  const listeCartesNombres = Object.keys(listNombres).map((item) => (
    <Card
      key={item}
      value={listNombres[item]}
      handleClick={handleNombre}
      refr={refresh}
      isNumber={true}
      setBgColor={setBgColor}
    />
  ));
  const listeCartesUnites = Object.keys(listUnites).map((item) => (
    <Card
      key={item}
      value={listUnites[item]}
      handleClick={handleUnite}
      refr={refresh}
      isNumber={false}
      setBgColor={setBgColor}
    />
  ));

  function toggleHelp() {
    setHelpIsDisplayed(!helpIsDisplayed);
  }

  function displayTab(tab) {
    var listElement = [];
    tab.forEach((element) => {
      listElement.push(
        <div
          key={element + "-" + Date.now() + Math.random()}
          className="border border-solid rounded w-24 h-24 text-lg border-orange-400 border-3 flex justify-center items-center m-4"
        >
          {element}
        </div>
      );
    });
    return listElement;
  }

  function calculMultiple(uniteString) {
    var multiple = 0;
    switch (uniteString) {
      case "Unités":
        multiple = 1;
        break;
      case "Dizaines":
        multiple = 10;
        break;
      case "Centaines":
        multiple = 100;
        break;
      case "Unités de mille":
        multiple = 1000;
        break;
      case "Dizaines de mille":
        multiple = 10000;
        break;
      case "Centaines de mille":
        multiple = 100000;
        break;
      case "Unités de millions":
        multiple = 1000000;
        break;
      case "Dizaines de millions":
        multiple = 10000000;
        break;
      case "Centaines de millions":
        multiple = 100000000;
        break;
      case "Dixièmes":
        multiple = 0.1;
        break;
      case "Centièmes":
        multiple = 0.01;
        break;
      case "Millièmes":
        multiple = 0.001;
        break;
    }
    return multiple;
  }

  function handleChange(e) {
    setInput(e.target.value);
  }
  function reset() {
    setIsCorrect(false);
    setNombreTab([]);
    setUniteTab([]);
    setInput("");
    setRefresh(refresh + 1);
  }
  function onClickModal() {
    toggleModal();
  }
  function setBgColor(isNumber) {
    var colorArray = [
      "#e74c3c",
      "#9b59b6",
      "#2980b9",
      "#1abc9c",
      "#27ae60",
      "#f1c40f",
      "#d35400",
      "#b3b6b7",
      "#5d6d7e",
      "#48c9b0",
    ];
    if (isNumber) {
      return colorArray[nombreTab.length];
    } else {
      return colorArray[uniteTab.length];
    }
  }
  function handleSubmit(e) {
    e.preventDefault();
    if (
      nombreTab.length === uniteTab.length &&
      nombreTab.length !== 0 &&
      input !== ""
    ) {
      if (calculResultat(remplacer_virgule_par_point(input))) {
        setIsCorrect(true);
        toggleModal();
      } else {
        setIsCorrect(false);
        toggleModal();
      }
    } else {
      toggleHelp();
    }
  }
  function remplacer_virgule_par_point(decimal) {
    return parseFloat((decimal + "").replace(",", "."));
  }
  function calculResultat(test) {
    var res = 0;
    if (uniteTab.length === nombreTab.length && nombreTab[0] !== null) {
      for (let i = 0; i < uniteTab.length; i++) {
        res = res + nombreTab[i] * calculMultiple(uniteTab[i]);
      }
    }
    res = res.toFixed(3);
    res = parseFloat(res);
    return res === test;
  }
  return (
    <div className="App">
      <p className="text-lg pt-4">
        Sélectionne les cartes nombres et les cartes unités que tu as tirées :
      </p>
      <div className="flex justify-center gap-10 my-8 p-8 flex-wrap">
        {listeCartesNombres}
      </div>
      <div className="flex justify-center gap-10 my-8 px-8 flex-wrap">
        {listeCartesUnites}
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          onChange={handleChange}
          value={input}
          placeholder="Ta réponse"
          className="border-2 border-solid h-12 text-xl border-slate-500 rounded-lg pl-4"
        />
        <input
          type="submit"
          value="Vérifier"
          className="px-3 bg-blue-500 m-4 h-12 text-white hover:bg-blue-300 font-bold rounded-lg"
        ></input>
        <button onClick={reset}>Remise à zéro</button>
        <div className={helpIsDisplayed ? "" : "hidden"}>
          <Help onClickHelp={toggleHelp} />
        </div>
      </form>
      <div className="flex flex-col items-center justify-center h-64">
        <div className="flex flex-row flex-wrap">{displayTab(uniteTab)}</div>
        <div className="flex flex-row flex-wrap">{displayTab(nombreTab)}</div>
      </div>
      <div className={modalIsDisplayed ? "" : "hidden"}>
        <Modal
          isCorrect={isCorrect}
          result={remplacer_virgule_par_point(input).toString()}
          nombreTab={nombreTab}
          uniteTab={uniteTab}
          onClickModal={onClickModal}
        ></Modal>
      </div>
    </div>
  );
}

export default App;
